// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SdG32D {
  position: relative;
  display: inline-block;
}

.oOowuk {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.oOowuk:hover {
  background-color: var(--surface-neutral-light);
}

.bVvMeO {
  font-size: var(--type-paragraph-md-font-size);
  color: var(--text-neutral-dark);
  width: 16px;
  height: 16px;
}

.yNxhOT {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-lg);
  width: 240px;
  animation: bDXNQF 0.2s ease-out;
  margin-top: var(--spacing-2);
}

@keyframes bDXNQF {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.yNxhOT::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--stroke-neutral-silver);
}

.yNxhOT::after {
  content: '';
  position: absolute;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid var(--surface-neutral-white);
}

.VJo7eU {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: var(--spacing-2) var(--spacing-2) var(--spacing-2);
  gap: var(--spacing-1-5);
}

.cs8wXz {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  flex: 1;
  padding: 0;
}

.SVTCUE {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  padding: 0;
}

.SVTCUE:hover {
  background-color: var(--surface-neutral-light);
}

.YU87uq {
  padding: 0 var(--spacing-2) var(--spacing-2);
  height: 92px;
  overflow-y: auto;
}

.jRUBBD {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.iMHvaA {
  padding: var(--spacing-1-5);
  border-top: 1px solid var(--stroke-neutral-subtle);
  display: flex;
  justify-content: flex-start;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/HappyHolidaysEndOfTheYearRechargePopover/HappyHolidaysEndOfTheYearRechargePopover.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,wCAAwC;EACxC,8CAA8C;EAC9C,8BAA8B;EAC9B,4BAA4B;EAC5B,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,2DAA2D;EAC3D,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;EAClD,aAAa;EACb,2BAA2B;AAC7B","sourcesContent":[".container {\n  position: relative;\n  display: inline-block;\n}\n\n.trigger {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n}\n\n.trigger:hover {\n  background-color: var(--surface-neutral-light);\n}\n\n.triggerIcon {\n  font-size: var(--type-paragraph-md-font-size);\n  color: var(--text-neutral-dark);\n  width: 16px;\n  height: 16px;\n}\n\n.popover {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-lg);\n  width: 240px;\n  animation: fadeIn 0.2s ease-out;\n  margin-top: var(--spacing-2);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.popover::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid var(--stroke-neutral-silver);\n}\n\n.popover::after {\n  content: '';\n  position: absolute;\n  top: -9px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 9px solid transparent;\n  border-right: 9px solid transparent;\n  border-bottom: 9px solid var(--surface-neutral-white);\n}\n\n.popoverHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: var(--spacing-2) var(--spacing-2) var(--spacing-2);\n  gap: var(--spacing-1-5);\n}\n\n.popoverTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  flex: 1;\n  padding: 0;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.closeButton:hover {\n  background-color: var(--surface-neutral-light);\n}\n\n.popoverContent {\n  padding: 0 var(--spacing-2) var(--spacing-2);\n  height: 92px;\n  overflow-y: auto;\n}\n\n.popoverDescription {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.popoverFooter {\n  padding: var(--spacing-1-5);\n  border-top: 1px solid var(--stroke-neutral-subtle);\n  display: flex;\n  justify-content: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SdG32D`,
	"trigger": `oOowuk`,
	"triggerIcon": `bVvMeO`,
	"popover": `yNxhOT`,
	"fadeIn": `bDXNQF`,
	"popoverHeader": `VJo7eU`,
	"popoverTitle": `cs8wXz`,
	"closeButton": `SVTCUE`,
	"popoverContent": `YU87uq`,
	"popoverDescription": `jRUBBD`,
	"popoverFooter": `iMHvaA`
};
module.exports = ___CSS_LOADER_EXPORT___;
